export const mockData = {
  company: {
    name: "JV3 Enterprise",
    tagline: "Premium Bitumen Export Solutions Worldwide",
    description: "Leading supplier of high-quality bitumen products for international markets. We deliver excellence in every shipment.",
    phone: "+91 93135 78934",
    email: "hello@jv3.in",
    address: "India"
  },
  
  hero: {
    title: "Premium Bitumen Export Solutions",
    subtitle: "Trusted by construction and infrastructure companies worldwide",
    description: "JV3 Enterprise delivers top-grade bitumen products with unmatched quality standards and reliable global shipping.",
    cta: "Get Quote"
  },
  
  about: {
    title: "About JV3 Enterprise",
    description: "With years of expertise in bitumen export, JV3 Enterprise has established itself as a reliable partner for businesses worldwide. We specialize in providing premium-grade bitumen products that meet international quality standards.",
    highlights: [
      "Global shipping network",
      "Quality assured products",
      "Competitive pricing",
      "Expert consultation"
    ]
  },
  
  products: [
    {
      name: "Penetration Grade Bitumen",
      grades: ["40/50", "60/70", "80/100"],
      description: "Ideal for road construction and pavement applications. Meets international specifications.",
      applications: ["Road Construction", "Pavement", "Highway Projects"]
    },
    {
      name: "Viscosity Grade Bitumen",
      grades: ["VG-10", "VG-20", "VG-30", "VG-40"],
      description: "Temperature-resistant bitumen for varying climate conditions and heavy-duty applications.",
      applications: ["Hot Climate Roads", "Heavy Traffic Areas", "Airport Runways"]
    },
    {
      name: "Oxidized Bitumen",
      grades: ["85/25", "90/15", "95/25"],
      description: "Specialized bitumen for industrial applications and waterproofing solutions.",
      applications: ["Waterproofing", "Industrial Flooring", "Pipe Coating"]
    },
    {
      name: "Cutback Bitumen",
      grades: ["MC-30", "MC-70", "RC-250"],
      description: "Liquid bitumen perfect for cold weather applications and surface treatments.",
      applications: ["Cold Weather Paving", "Surface Treatment", "Prime Coating"]
    }
  ],
  
  whyChooseUs: [
    {
      title: "Premium Quality",
      description: "All our bitumen products undergo rigorous quality testing to meet international standards.",
      icon: "award"
    },
    {
      title: "Global Reach",
      description: "Extensive shipping network ensuring timely delivery to any corner of the world.",
      icon: "globe"
    },
    {
      title: "Competitive Pricing",
      description: "Best market rates without compromising on quality. Volume discounts available.",
      icon: "trending-down"
    },
    {
      title: "Expert Support",
      description: "Dedicated team of bitumen specialists to assist with product selection and technical queries.",
      icon: "users"
    },
    {
      title: "Reliable Supply",
      description: "Consistent product availability and on-time delivery with complete documentation.",
      icon: "truck"
    },
    {
      title: "Custom Solutions",
      description: "Tailored bitumen specifications to meet your specific project requirements.",
      icon: "settings"
    }
  ],
  
  testimonials: [
    {
      name: "Ahmed Al-Rashid",
      company: "Gulf Construction Co.",
      country: "UAE",
      text: "JV3 Enterprise has been our trusted bitumen supplier for over 3 years. Their product quality is exceptional and delivery is always on time.",
      rating: 5
    },
    {
      name: "Michael Chen",
      company: "Pacific Roads Ltd.",
      country: "Singapore",
      text: "Outstanding service and competitive pricing. The VG-30 bitumen we sourced from JV3 performed excellently in our highway project.",
      rating: 5
    },
    {
      name: "Rajesh Kumar",
      company: "Metro Infrastructure",
      country: "India",
      text: "Professional team with deep knowledge of bitumen products. They helped us choose the right grade for our climate conditions.",
      rating: 5
    },
    {
      name: "David Williams",
      company: "African Build Solutions",
      country: "Kenya",
      text: "Reliable partner for our construction projects. JV3's bitumen quality and documentation process is impeccable.",
      rating: 5
    }
  ]
};
